import TextCategoriesBlock from './textCategoriesBlock'

export default TextCategoriesBlock
